<template>
  <div class="main">
  	<div class="top">
    	<img src="/static/img/help.png" class="top-img">
    </div>
    <div class="box">
    	<div class="left">
    		<div v-for="(item , index) in list" @click="checkTag(index)" class="left-list">
    			<div class="list-tag" :class="tagIndex == index ? 'list-is' : 'list-no'"></div>
    			<div :class="tagIndex == index ? 'list-name' :''">{{item.name}}</div>
    		</div>
    	</div>
    	<div class="right">
    		<div v-if="tagIndex == 0">
    			<div v-for="(item , index) in problemList">
    				<div class="p-list" @click="checkPro(index)">
	    				<div class="p-list-dian"></div>
	    				<div>{{item.title}}</div>
    				</div>
    				<div class="p-lists" v-if="problemIndex == index">
    					<div v-html="item.content"></div>
	    				<!-- <div v-for="(items , indexs) in item.list">
	    					<div>{{indexs + 1}}、{{items.que}}</div>
	    					<div>答：{{items.ans}}</div>
	    				</div> -->
    				</div>
    			</div>
    		</div>
    		<div v-if="tagIndex == 1">
    			<div class="back-top">
    				<div class="b-title">欢迎反馈问题！</div>
    				<el-input class="b-input" type="textarea" v-model="backForm.content" :autosize="{ minRows: 4 , maxRows: 6}" placeholder="输入反馈："></el-input>
    				<div class="b-sub">
	    				<el-select class="b-input"  placeholder="选择分类" v-model="backForm.region">
	                        <el-option
	                            v-for="item in options"
	                            :key="item.value"
	                            :label="item.label"
	                            :value="item.value">
	                        </el-option>
	                    </el-select>
	                    <div class="b-btn" @click="sendIssue">提交</div>
                    </div>
    			</div>
    			<div class="classify-list">
			    	<div class="list-box">
			    		<div :class="checkNum === null ? 'list-sel' : 'list-not'" @click="selAll">全部</div>
			    		<div :class="checkNum == item.id ? 'list-sel' : 'list-not'" v-for="(item,index) in tabList" :key="index" @click="selClassify(item.id)">{{item.name}}</div>
			    	</div>
			    </div>
			    <div class="f-lists">
			    	<div v-for="(item , index) in feedbackList" class="f-list">
			    		<div class="f-left">
			    			<img class="f-img" :src="$avatarHash(item.userid)" alt="" v-if="item.userid != null">
                            <img class="f-img" src="/static/img/anonymity.png" alt="" v-else>
			    		</div>
			    		<div>
			    			<div>
			    				<div class="r-name" v-if="item.username != null">{{item.username}}</div> 
                                <div class="r-name" v-else>匿名</div>
                                <div class="r-content">{{item.content}}</div>
                                <div class="r-bottom">
                                	<div class="r-time">{{item.createdtime}}</div>
                                	<div class="r-reply" v-if="isAdmin && !item.reply" @click.stop="item.showInput = !item.showInput">回复</div>
                                </div>
                                <div v-if="item.showInput" class="r-reply-list">
                                	<el-input style="width:80%;" :rows="1" type="textarea" class="b-input" v-model="item.text" placeholder="回复："></el-input>
                                	<div class="r-reply-list-btn" @click="submitReply(item)">提交</div>
                                </div>
			    			</div>
			    			<div v-if="item.replyid" class="r-list">
			    				<div class="r-left">
			    					<img class="r-img" :src="$avatarHash(item.replyid)" >
			    				</div>
			    				<div>
			    					<div class="r-name">{{item.replyname}}</div> 
			    					<div class="r-content">{{item.reply}}</div>
                                    <div class="r-time">{{item.updated_at}}</div>
			    				</div>
			    			</div>
			    		</div>
			    	</div>
			    	<div v-if="total == 0" class="no-back">暂时没有问题反馈哦！</div>
			    </div>
    		</div>
    		<div v-if="tagIndex == 2">
    			<div class="aboutUs">
    				<div>
    					<span class="a-title">在线客服</span>
    					<span class="a-desc">周一至周五09:00-18:00，您可以随时在平台私信弘小九哦～</span>
    				</div>
    				<div class="a-list">
    					<img src="/static/img/hxj.png" class="a-img">
    					<div class="a-name">弘小九</div>
    					<div class="a-btn" @click="gotoChat">私信</div>
    				</div>
    			</div>
    			<div class="aboutUs">
    				<div>
    					<span class="a-title">联系方式</span>
    					<span class="a-desc">周一至周五09:00-18:00</span>
    				</div>
    				<div class="a-list">
    					<img src="/static/img/phone.png" class="a-icon">
    					<div class="a-contact">0755-8254 7304</div>
    					<img src="/static/img/address.png"  class="a-icon">
    					<div class="a-contact">广东省深圳市福田区滨河大道5022号联合广场A座56D</div>
    				</div>
    			</div>
    			<div class="aboutUs">
    				<div>
    					<span class="a-title">官方微信服务号</span>
    					<span class="a-desc">关注微信服务号，随时关注平台动态</span>
    				</div>
    				<div class="a-list">
    					<div class="a-wechat">
    						<img src="/static/img/qrcode.png"  class="a-w-img">
    						<div>更多法律服务</div>
    					</div>
    					<div class="a-wechat">
    						<img src="/static/img/wechat.png" class="a-w-img">
    						<div>法律咨询/活动报名</div>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'Help',
  data () {
    return {
      list:[
      	{name:'常见问题'},
      	{name:'问题反馈'},
      	{name:'联系我们'}
      ],
      tagIndex:0,
      problemList:[
      	// {name:'pc登录注册问题',list:[{que:'如何注册？',ans:'通过手机号验证快速注册'},{que:'如何注册？',ans:'通过手机号验证快速注册'},{que:'如何注册？',ans:'通过手机号验证快速注册'}]}
      ],
      search:'',
      problemIndex:0,
      backForm:{
      	content:'',
      	region:null
      },
      options:[
      	{
        value: 0,
        label: '其他问题'
        }, {
            value: 1,
            label: '功能问题'
        }, {
            value: 2,
            label: '页面效果'
        }, {
            value: 3,
            label: '提点建议'
        }
      ],
      checkNum : null,
      tabList:[
      	{name:'功能问题',id:1},{name:'页面效果',id:2},{name:'提点建议',id:3},{name:'其他问题',id:0}
      ],
      feedbackList:[],
      total:''
    }
  },
  computed:{
  	isLogin() {
        return this.$store.state.loginStatus;
    },
    isAdmin() {
        return this.$store.state.mineInfo.id == HONSEN_id;
    }
  },
  mounted(){
  	this.tagIndex = this.$route.params.type || 0; //跳转页面来的状态，0常见问题，1问题反馈，2联系我们
  	this.getHelpList();
  	this.getfeedback();
  },
  methods:{
  	//跳转私信
  	gotoChat() {
      if( !this.isLogin ){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        setTimeout(() => {
          this.$message.warning( '请先登录后，再次执行操作！' );
        }, 200);
        return;
      }
      // this.$gotov1('/feed?v2chat=' + this.userInfo.id);
      this.startGetInfo(398)

    },

    //客服回复反馈
    submitReply(oData) {
        if (oData.text.trim().length > 1) {
            this.$ajax('post', '/feedback/reply', {id: oData.id, reply: oData.text}, (data) => {
                oData.reply = oData.text;
                oData.replyname = '弘商管家';
                oData.replyid = HONSEN_id;
                oData.updated_at = moment().format('YYYY-MM-DD HH:mm:ss');
                oData.showInput = false;
            });
        } else {
             this.$Message.error('回复内容不能为空');
             return false
        }
    },

    startGetInfo(uid) {
      this.$ajax('get', `/userinfo/detail/${uid}`, (data) => {
          this.startChat(data.data);
      });
    },
    startChat(user) {
        if(this.$store.state.mineInfo && this.$store.state.mineInfo.id){
            this.$store.commit("changeCurcontactInfo", { id: user.id, name: user.name});

            if(!this.isshowchatpanel){
                this.$store.commit('setSide', 'chat');
            }
        }else{
            this.$Message.error('未登录，请先登录后再发起私信！');
        }
    },
  	//获取常见问题列表
  	getHelpList(){
  		let url = 'help/faq/list';
  		let param = {
  			search:this.search
  		};
  		this.$http.get(url, {params:param} ).then(res => {
  			if(res.data.retcode == $conf.RETCODE_OK){
  				this.problemList = res.data.data;
  			}
  		})
  	},
  	checkTag(index){
  		this.tagIndex = index;
  	},
  	checkPro(index){
  		this.problemIndex = index;
  	},
  	//全选
  	selAll(){
  		this.checkNum = null;
  		this.getfeedback();
  	},
  	//选择标签
  	selClassify(id){
  		this.checkNum = id;
  		this.getfeedback();
  	},
  	//获取问题反馈
  	getfeedback() {
        let url = 'feedback/feedbacklist';
        let option = {
            perpage: 50
        };
        if (this.checkNum != null) {
            option.type = this.checkNum
        };
        this.$ajax('post', url, option, res => {
        	res.data.data = res.data.data.map(val =>{
        		val.showInput = false;
        		val.text = '';
        		return val;
        	})
            this.feedbackList = res.data.data;
            this.total = res.data.total;
        });
    },
    //提交反馈
    sendIssue(){
    	if(this.backForm.content == ''){
    		this.$message.error('请输入反馈问题！');
    	}else if(this.backForm.region == null){
    		this.$message.error('请选择反馈分类！');
    	}else{
    		let option = {
            	content: this.backForm.content
	        }
	        if (this.backForm.region != null) {
	            option.type = this.backForm.region;
	        }
	        if (this.isLogin) {
	            option.creator = this.$store.state.mineInfo.id;
	        }
	        let url = 'feedback/create';
	        this.$ajax('post', url, option , res => {
	            this.sendIssueLoading = false;
	            this.$message.success('发布成功');
	            this.backForm.content = '';
	            this.backForm.region = null;
	            this.getfeedback();
	        })
    	}
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
	.top
		width:100%;
		.top-img
			width:100%;
			height:298px;
	.box
		display:flex;
		margin-bottom:100px;
		.left
			padding:10px 0px;
			margin-left:300px;
			width:219px;
			text-align:center;
			border-right:1px solid rgba(234,234,234,1);
			height:600px;
			.left-list
				display:flex;
				justify-content: center;
				align-items:center;
				cursor:pointer;
				margin-bottom:43px;
				font-size:22px;
				font-weight:400;
				color:rgba(7,19,54,0.6);
				.list-tag
					width:4px;
					height:22px;
					border-radius:3px;
					margin-right:11px;
				.list-is
					background:rgba(255,181,0,1);
				.list-no
					background:rgba(255,255,255,1);
				.list-name
					color:rgba(7,19,54,1);
		.right
			margin:10px 0 60px 60px;
			width:55%;
			.p-list
				display:flex;
				align-items:center;
				cursor:pointer;
				margin:20px 0px 10px 0px;
				width:1025px;
				height:38px;
				font-size:18px;
				font-weight:400;
				color:rgba(7,19,54,1);
				line-height:38px;
				letter-spacing:1px;
				.p-list-dian
					width:6px;
					height:6px;
					background:rgba(39,81,203,1);
					border-radius:5px;
					margin-right:10px;
			.p-lists
				margin-left:10px;
				font-size:16px;
				font-weight:400;
				color:rgba(7,19,54,0.6);
				letter-spacing:1px;
				line-height:30px;
			.back-top
				.b-title
					height:38px;
					font-size:18px;
					font-weight:500;
					color:rgba(7,19,54,1);
					line-height:38px;
					letter-spacing:1px;
				.b-sub
					display:flex;
					justify-content:space-between;
					align-items:center;
					margin-top:15px;
					.b-btn
						width:70px;
						height:36px;
						line-height:36px;
						text-align:center;
						cursor:pointer;
						background:rgba(39,81,203,1);
						border-radius:22px;
						border:1px solid rgba(39,81,203,1);
						font-size:14px;
						font-weight:500;
						color:rgba(255,255,255,1);
			.classify-list
				margin-top:47px;
				padding-bottom:19px;
				border-bottom:1px solid rgba(241,241,241,1);
				.list-box
					display:flex;
					align-items:center;
					.list-sel
						height:27px;
						padding:0 10px;
						line-height:27px;
						background:rgba(39,81,203,1);
						border-radius:20px;
						font-size:14px;
						font-weight:400;
						color:rgba(255,255,255,1);
						text-align:center;
						margin-right:20px;
						cursor:pointer
					.list-not
						height:27px;
						padding:0 10px;
						line-height:27px;
						border-radius:20px;
						font-size:14px;
						font-weight:400;
						color:#676F86;
						text-align:center;
						margin-right:20px;
						cursor:pointer;
			.f-lists
				margin-top:40px;
				.f-list
					display:flex;
					margin-bottom:20px;
					.f-left
						width:60px;
						.f-img
							width:44px;
							height:44px;
							border-radius:48px;
				.r-name
					height:22px;
					font-size:16px;
					font-weight:500;
					color:rgba(7,19,54,1);
					line-height:22px;
				.r-content
					height:20px;
					font-size:14px;
					font-weight:400;
					color:rgba(7,19,54,0.8);
					line-height:20px;
					margin-top:6px;
				.r-reply-list
					display:flex;
					justify-content:space-between;
					align-items:center;
					width:500px;
					margin-top:10px;
					.r-reply-list-btn
						width:70px;
						height:30px;
						line-height:30px;
						text-align: center;
						cursor: pointer;
						background: #2751cb;
						border-radius: 22px;
						font-size: 14px;
						color:#fff;
				.r-bottom
					display:flex;
					align-items:center;
					margin-top:10px;
					.r-time
						height:17px;
						font-size:12px;
						font-weight:400;
						color:rgba(7,19,54,0.4);
						line-height:17px;
					.r-reply
						margin-left:10px;
						cursor:pointer;
				.r-list
					display:flex;
					background:rgba(247,248,249,1);
					width:970px;
					padding:10px;
					margin-top:20px;
					.r-time
						height:17px;
						font-size:12px;
						font-weight:400;
						color:rgba(7,19,54,0.4);
						line-height:17px;
						margin-top:10px;
					.r-left
						width:60px;
						.r-img
							width:44px;
							height:44px;
							border-radius:48px;
				.no-back
					text-align:center;
					margin-top:100px;
			.aboutUs
				padding:20px 0px;
				border-bottom:1px solid rgba(241,241,241,1);
				.a-title
					height:38px;
					font-size:18px;
					font-weight:500;
					color:rgba(7,19,54,1);
					line-height:38px;
					letter-spacing:1px;
				.a-desc
					height:20px;
					font-size:14px;
					font-weight:400;
					color:rgba(7,19,54,0.4);
					line-height:20px;
					margin-left:20px;
				.a-list
					display:flex;
					align-items:center;
					margin-top:20px;
					.a-img
						width:39px;
						height:39px;
						border-radius:50%;
						margin-right:10px;
					.a-name
						height:24px;
						font-size:14px;
						font-weight:400;
						color:rgba(7,19,54,1);
						line-height:24px;
						margin-right:29px;
					.a-btn
						cursor:pointer;
						padding:0px 19px;
						height:36px;
						line-height:36px;
						background:rgba(39,81,203,1);
						border-radius:22px;
						border:1px solid rgba(39,81,203,1);
						font-size:14px;
						font-weight:500;
						color:rgba(255,255,255,1);
					.a-icon
						width:20px;
						height:20px;
						margin-right:6px;
					.a-contact
						height:24px;
						font-size:16px;
						font-weight:400;
						color:rgba(7,19,54,0.8);
						line-height:24px;
						letter-spacing:1px;
						margin-right:50px;
					.a-wechat
						text-align:center;
						margin-right:45px;
						.a-w-img
							width:96px;
							height:96px;
</style>
<style lang="stylus">
.b-input
	.el-textarea__inner , .el-input__inner
		background:#F7F8F9;
		border-radius:5px;
</style>


// WEBPACK FOOTER //
// src/components/help/help.vue